/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import DayPicker, { DateUtils } from "../DayPicker/DayPicker";
import InputDate from "../InputDate";
import { DateRangeIcon, ArrowDropDownIcon } from "../../theme/assets";
import classnames from "classnames";
import { Overlay } from "react-overlays";
import "./styles.scss";
import constants from "../../utils/constants";

const INPUT_DATE_TYPE = {
  START: "from",
  END: "to",
};

class CalendarPicker extends Component {
  constructor(props) {
    super(props);

    // Binding methods
    this.handleHideDate = this.handleHideDate.bind(this);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleOnInputClick = this.handleOnInputClick.bind(this);
    this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);

    /**
     * @type {Object}
     * @property show               - If the day picker is shown or not
     * @property to                 - Date 'from' day picker
     * @property from               - Date 'to' day picker
     */
    this.state = {
      show: false,
      to: props.to,
      from: props.from,
      startMonth: props.from,
      isSelectingLastDay: false,
    };

    this.input = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.to !== this.props.to || prevProps.from !== this.props.from) {
      this.setState({
        to: this.props.to,
        from: this.props.from,
        startMonth: this.props.from,
      });
    }
  }

  handleMonthChange(month) {
    this.setState({ startMonth: month });
  }

  handleDayMouseEnter(day) {
    const { from } = this.state;
    if (
      this.state.activeInput === INPUT_DATE_TYPE.START ||
      (from && day < from) ||
      DateUtils.isSameDay(day, from)
    ) {
      return;
    }
    if (
      this.props.deviceInfo &&
      this.props.deviceInfo.deviceType === constants.DEVICE_TYPE.DESKTOP
    ) {
      this.setState({
        to: day,
      });
    }
  }

  reset() {
    this.setState({
      from: null,
      to: null,
    });
  }

  /* TODO: OPTIMIZE THIS METHOD IT'S UGLY! */
  handleDayClick(day, { disabled }) {
    if (disabled) {
      return;
    }
    const state = {};
    if (this.state.activeInput === INPUT_DATE_TYPE.START) {
      if (!this.state.from || this.state.from > day) {
        state.from = day;
        state.activeInput = INPUT_DATE_TYPE.END;
        state.isSelectingLastDay = true;
        this.setState(state);
        this.props.onChange({ start: state.from, end: state.to });
      }

      if (this.state.from < day) {
        state.from = day;
        state.activeInput = INPUT_DATE_TYPE.END;
        state.isSelectingLastDay = true;
        if (this.state.to && this.state.to <= day) {
          state.to = null;
        }
        this.setState(state);
        this.props.onChange({ start: state.from, end: state.to });
      }
    }

    if (this.state.activeInput === INPUT_DATE_TYPE.END) {
      if (!this.state.to || this.state.to < day) {
        state.to = day;

        if (this.state.from && this.state.from >= day) {
          state.from = day;
          state.to = null;
          state.isSelectingLastDay = false;
        } else {
          state.isSelectingLastDay = true;
          this.handleHideDate();
        }

        this.setState(state);
        this.props.onChange({ start: state.from, end: state.to });
      }

      if (this.state.to >= day) {
        state.to = day;
        if (!this.state.from || (this.state.from && this.state.from >= day)) {
          state.from = day;
          state.to = null;
          state.isSelectingLastDay = false;
          this.setState(state);
          this.props.onChange({ start: state.from, end: state.to });
        } else {
          state.isSelectingLastDay = true;
          this.setState(state);
          this.handleHideDate();
          this.props.onChange({
            start: state.from,
            end: state.to,
            isSelectingLastDay: state.isSelectingLastDay,
          });
        }
      }
    }
  }

  handleHideDate() {
    if (!this.activeInput) {
      this.setState({
        show: false,
        activeInput: false,
      });
    }
  }

  handleOnInputClick(event, type) {
    this.setState({
      show: true,
      activeInput: type,
    });
    /* HACK in order to not close the overlay when clicking the inputs */
    this.activeInput = type;
    setTimeout(() => {
      this.activeInput = false;
    }, 1);
  }

  render() {
    const { to, from, onClean, fullWidth } = this.props;
    const modifiers = {
      selected: day => DateUtils.isDayInRange(day, this.state),
      startDay: day => DateUtils.isSameDay(day, this.state.from),
      endDay: day => DateUtils.isSameDay(day, this.state.to),
    };
    if (this.props.minDate) {
      modifiers.disabled = date => date < this.props.minDate;
    }
    const isDisabled = !(this.state.to instanceof Date) || !(this.state.from instanceof Date);
    const isDisabledClassName = classnames({
      "is-disabled": isDisabled,
    });
    return (
      <div className={classnames("wbkv9-CalendarPicker", "Calendar")}>
        <div
          ref={this.input}
          className={classnames("wbkv9-CalendarPicker-DateRange", "dateRange")}
          onClick={(event, day) =>
            fullWidth &&
            window.innerWidth > 984 &&
            this.handleOnInputClick(event, INPUT_DATE_TYPE.START)
          }>
          <div className={classnames("wbkv9-CalendarPicker-DateRangeIcon", "dateRangeIcon")}>
            <DateRangeIcon />
          </div>

          <div className={classnames("wbkv9-CalendarPicker-startDate", "startDate")}>
            <InputDate
              date={this.state.from}
              fullWidth={fullWidth}
              label={"?"}
              onClick={(event, day) =>
                (!fullWidth || window.innerWidth < 985) &&
                this.handleOnInputClick(event, INPUT_DATE_TYPE.START)
              }
              onClean={onClean}
              active={this.state.show && this.state.activeInput === INPUT_DATE_TYPE.START}
            />
            <div
              className={classnames(
                "wbkv9-CalendarPicker-overlayTriangle",
                "Calendar-overlayTriangle",
                this.state.activeInput === INPUT_DATE_TYPE.START && "active"
              )}></div>
          </div>

          <div className={classnames("wbkv9-CalendarPicker-DateSeparator", "dateSeparator")}>-</div>

          <div className={classnames("wbkv9-CalendarPicker-endDate", "endDate")}>
            <InputDate
              date={this.state.to}
              fullWidth={fullWidth}
              label={"?"}
              onClick={(event, day) =>
                (!fullWidth || window.innerWidth < 985) &&
                this.handleOnInputClick(event, INPUT_DATE_TYPE.END)
              }
              onClean={onClean}
              active={this.state.show && this.state.activeInput === INPUT_DATE_TYPE.END}
            />
            <div
              className={classnames(
                "wbkv9-CalendarPicker-overlayTriangle",
                "Calendar-overlayTriangle",
                this.state.activeInput === INPUT_DATE_TYPE.END && "active"
              )}></div>
          </div>

          <div
            className={classnames("wbkv9-CalendarPicker-DateRangeArrowDown", "dateRangeArrowDown")}>
            <ArrowDropDownIcon />
          </div>
        </div>

        <Overlay
          placement="bottom"
          onHide={this.handleHideDate}
          show={this.state.show}
          container={this}
          target={this.input.current}
          rootClose>
          {({ props }) => (
            <div
              className={classnames("wbkv9-CalendarPicker-overlay", "Calendar-overlay")}
              {...props}>
              <DayPicker
                initialMonth={this.state.startMonth || new Date()}
                numberOfMonths={2}
                modifiers={modifiers}
                onDayClick={this.handleDayClick}
                onDayMouseEnter={this.handleDayMouseEnter}
                onMonthChange={this.handleMonthChange}
              />
            </div>
          )}
        </Overlay>
      </div>
    );
  }
}

CalendarPicker.propTypes = {
  to: PropTypes.instanceOf(Date),
  from: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  onClean: PropTypes.func,
};

CalendarPicker.defaultProps = {
  onChange() {},
  onClean() {},
};

export default CalendarPicker;
